const schema = () => ({
  type: "object",
  required: [],
  properties: {
    details: {
      type: "string",
      title: "علت رد درخواست",
    },
  },
});

export default schema;
